

require('../css/app.less');

var _logger = require('components/xo-beaver/dist/logger');

var _route = require('pages/xo-checkout/route');

var _route2 = _interopRequireDefault(_route);

var _middleware = require('js/lib/middleware');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_logger.$logger.info('app_bootstrap', {
    hash: window.location.hash
});

var xoCheckoutRoute = new _route2['default']();

xoCheckoutRoute.bootstrap('checkout.landing', _middleware.$Middleware);

window.bootstrap = true;

_logger.$logger;

_middleware.$Middleware;


/*****************
 ** WEBPACK FOOTER
 ** ./js/app.js
 ** module id = 104
 ** module chunks = 1
 **/